import secureApi from './secureApi';

export default function Api() {
  function post(api, hdata, scallback, ecallback) {
    let req;

    if (typeof api !== 'string' && 'api' in api) {
      req = api;
    } else {
      req = { api, hdata, scallback, ecallback };
    }

    secureApi
      .post(req.api, req.hdata)
      .then((res) => {
        // Call success callback if provided
        if (req.scallback) {
          req.scallback(res);
        }
      })
      .catch((err) => {
        // Call error callback if provided
        if (req.ecallback) {
          req.ecallback(err);
        } else {
          console.error('API Error:', err);
        }
      });
  }

  this.post = post;
}

